import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  DialogContentText,
} from '@mui/material';

const CustomDialog = ({
  open,
  onClose,
  title,
  content,
  actions,
  icon = null,
  maxWidth = 'sm',
  fullWidth = true,
  align = 'center',
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      PaperProps={{
        style: {
          textAlign: align,
          padding: '20px',
          borderRadius: '15px',
        },
      }}
    >
      {title && (
        <DialogTitle>
          <Typography variant="h5" color="primary">
            {icon && (
              <span style={{ verticalAlign: 'middle', marginRight: 8 }}>
                {icon}
              </span>
            )}
            {title}
          </Typography>
        </DialogTitle>
      )}

      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>

      {actions && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  );
};

export default CustomDialog;
